import { NavigationData } from "../services/Navigation/Navigation.interface";

  export const SiteNavigation: NavigationData = {
    root: "app-page-home",
    menu: {
      restriction: "completedProfile",
      url: "/",
      type: "menu",
      subRoutes: {
        "services": {
          component: "site-page-home", // No direct component since it's now a dropdown
          icon: "",
          url: "/", // Use "#" as placeholder
          dropdownItems: [
            {
              name: "All Services",
              labels: { 
                EN: "All Services", 
              FR: "Tous les services", 
              NL: "Alle diensten" },
              url: "/services",
              component: "site-page-services"
            },
            // Add more dropdown items here if necessary
          ]
        },
        "blog": {
          component: "site-page-blog",
          icon: "",
          url: "/blog"
        },
        "contact": {
          component: "site-page-contact",
          icon: "",
          url: "/contact"
        },
      },
      labels: {
        EN: { 
          "services": "Services", 
          "blog": "Advices", "contact": 
          "Contact Us" },
        FR: { 
          "services": "Services", 
          "blog": "Conseils", "contact": 
          "Contactez-nous" },
        NL: { 
          "services": "Diensten", 
          "blog": "Advies", "contact": 
          "Contacteer ons" }
      }
    },
    routes: {
      "serviceDetailPage1": { 
        url: "/services/solutions-technique", 
        component: "site-page-service-detail" 
      },
      "serviceDetailPage1_en": { 
        url: "/en/services/solutions-technique", 
        component: "site-page-service-detail" 
      },
      "serviceDetailPage1_nl": { 
        url: "/nl/services/solutions-technique", 
        component: "site-page-service-detail" 
      },
      "serviceDetailPage2": { 
        url: "/services/solutions-digitale", 
        component: "site-page-service-detail-2" 
      },
      "serviceDetailPage2_en": { 
        url: "/en/services/solutions-digitale", 
        component: "site-page-service-detail-2" 
      },
      "serviceDetailPage2_nl": { 
        url: "/nl/services/solutions-digitale", 
        component: "site-page-service-detail-2" 
      },
      "serviceDetailPage3": { 
        url: "/services/solutions-mobilite", 
        component: "site-page-service-detail-3" 
      },
      "serviceDetailPage3_en": { 
        url: "/en/services/solutions-mobilite", 
        component: "site-page-service-detail-3" 
      },
      "serviceDetailPage3_nl": { 
        url: "/nl/services/solutions-mobilite", 
        component: "site-page-service-detail-3" 
      },
      "serviceDetailPage4": { 
        url: "/services/solutions-b2c", 
        component: "site-page-service-detail-4" 
      },
      "serviceDetailPage4_en": { 
        url: "/en/services/solutions-b2c", 
        component: "site-page-service-detail-4" 
      },
      "serviceDetailPage4_nl": { 
        url: "/nl/services/solutions-b2c", 
        component: "site-page-service-detail-4" 
      },
      "home_en": { 
        url: "/en", 
        component: "site-page-home" 
      },
      "home_nl": { 
        url: "/nl", 
        component: "site-page-home" 
      },
      "services_en": { 
        url: "/en/services", 
        component: "site-page-services" 
      },
      "services_nl": { 
        url: "/nl/services", 
        component: "site-page-services" 
      },
      "blogPage": { 
        url: "/blog", 
        component: "site-page-blog" 
      },
      "blogPage_en": { 
        url: "/en/blog", 
        component: "site-page-blog" 
      },
      "blogPage_nl": { 
        url: "/nl/blog", 
        component: "site-page-blog" 
      },
      "articlePage1": { 
        url: "/blog/conseils-de-securite-electrique-pour-votre-maison", 
        component: "site-page-blog-article" 
      },
      "articlePage1_en": { 
        url: "/en/blog/conseils-de-securite-electrique-pour-votre-maison", 
        component: "site-page-blog-article" 
      },
      "articlePage1_nl": { 
        url: "/nl/blog/conseils-de-securite-electrique-pour-votre-maison", 
        component: "site-page-blog-article" 
      },
      "articlePage2": { 
        url: "/blog/conseils-de-securite-en-plomberie-pour-votre-maison", 
        component: "site-page-blog-article-2" 
      },
      "articlePage2_en": { 
        url: "/en/blog/conseils-de-securite-en-plomberie-pour-votre-maison", 
        component: "site-page-blog-article-2" 
      },
      "articlePage2_nl": { 
        url: "/nl/blog/conseils-de-securite-en-plomberie-pour-votre-maison", 
        component: "site-page-blog-article-2" 
      },
      "articlePage3": { 
        url: "/blog/conseils-de-prevention-en-moisissures-dans-votre-maison", 
        component: "site-page-blog-article-3" 
      },
      "articlePage3_en": { 
        url: "/en/blog/conseils-de-prevention-en-moisissures-dans-votre-maison", 
        component: "site-page-blog-article-3" 
      },
      "articlePage3_nl": { 
        url: "/nl/blog/conseils-de-prevention-en-moisissures-dans-votre-maison", 
        component: "site-page-blog-article-3" 
      },
      "articlePage4": { 
        url: "/blog/conseils-pour-une-isolation-efficace-de-votre-maison", 
        component: "site-page-blog-article-4" 
      },
      "articlePage4_en": { 
        url: "/en/blog/conseils-pour-une-isolation-efficace-de-votre-maison", 
        component: "site-page-blog-article-4" 
      },
      "articlePage4_nl": { 
        url: "/nl/blog/conseils-pour-une-isolation-efficace-de-votre-maison", 
        component: "site-page-blog-article-4" 
      },
      "contactPage": { 
        url: "/contact", 
        component: "site-page-contact" 
      },
      "contactPage_en": { 
        url: "/en/contact", 
        component: "site-page-contact" 
      },
      "contactPage_nl": { 
        url: "/nl/contact", 
        component: "site-page-contact" 
      },
      "terms": { 
        url: "/conditions-generales", 
        component: "site-page-terms" 
      },
      "terms_en": { 
        url: "/en/conditions-generales", 
        component: "site-page-terms" 
      },
      "terms_nl": { 
        url: "/nl/conditions-generales", 
        component: "site-page-terms" 
      },
      "policy": { 
        url: "/politique-de-confidentialite", 
        component: "site-page-policy" 
      },
      "policy_en": { 
        url: "/en/politique-de-confidentialite", 
        component: "site-page-policy" 
      },
      "policy_nl": { 
        url: "/nl/politique-de-confidentialite", 
        component: "site-page-policy" 
      }
    },
    routeGuards: {},
    redirects: []
  };
  
